import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'pennant-icon',
  templateUrl: './pennant-icon.component.html',
  styleUrls: ['./pennant-icon.component.scss']
})
export class PennantIconComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
